<script setup lang="ts">
import AppChrome from "./components/AppChrome.vue";
import ErrorBanner from "./components/common/ErrorBanner.vue";
import { useErrorStore, installGlobalErrorHandlers } from "@/stores/errorStore";

// 注册全局错误处理（unhandledrejection / window.onerror）
installGlobalErrorHandlers(useErrorStore());
</script>

<template>
  <AppChrome />
  <ErrorBanner />
</template>

<style>
#app {
  min-height: 100vh;
}
</style>